(function () {
  if(!document.querySelector(".sticky-element")) return this;

  const stickyElement = document.querySelector('.sticky-element');
  const body = document.querySelector('body');
  window.addEventListener('scroll', () => {
    const rect = stickyElement.getBoundingClientRect();
    
    if (rect.top <= 0) {
      body.classList.add('fixed');
    } else {
      body.classList.remove('fixed');
    }
  });

    const toggleElement = document.querySelector('.sidebar_mobile');
    const caption = toggleElement.querySelector('.toggle-sidebar');
    let isOpen = false;

    if (caption) {
      // 初期のaria属性を設定
      caption.setAttribute('role', 'button');
      caption.setAttribute('aria-expanded', 'false');
      caption.setAttribute('tabindex', '0');

      // クリックイベント
      caption.addEventListener('click', toggleTable);
      caption.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          toggleTable();
          e.preventDefault();  // Spaceキーのデフォルト動作を防ぐ
        }
      });

      function toggleTable() {
        isOpen = !isOpen;
        toggleElement.classList.toggle('is-open', isOpen);

        // aria-expandedを更新
        caption.setAttribute('aria-expanded', isOpen);
      }
    }

})();